import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import DomPurify from 'dompurify';
import { SearchIcon } from '../../../commons/icons/Search';

export const NoAccountsFound: FC = () => {
  const { t } = useTranslation();
  const sanitizer = DomPurify.sanitize;

  return (
    <div className="multi-account__admin__table-search">
      <div className="multi-account__admin__table-search-box">
        <SearchIcon className="icon-search" />
        <p dangerouslySetInnerHTML={{ __html: sanitizer(t('multiAccount.noAccountsFound')) }} />
      </div>
    </div>
  );
};
